import { Navigate } from "react-router-dom"
import { Feature } from "lib/@components/feature"
import {
    FEATURE_FLAG_LEGISLATION_RESOLUTIONS,
    LEGISLATION_RESOLUTIONS_PAGE_DEMANDS,
} from "./feature-flag-legislation-resolutions"
import { ResolutionDetailContent } from "./resolution-detail-content"
import DemandGuard from "minimals-template/components/guards/DemandGuard"

export function ResolutionDetailPage() {
    return (
        <Feature feature={FEATURE_FLAG_LEGISLATION_RESOLUTIONS} fallback={<Navigate to="/app" replace />}>
            <DemandGuard demands={LEGISLATION_RESOLUTIONS_PAGE_DEMANDS} and>
                <ResolutionDetailContent />
            </DemandGuard>
        </Feature>
    )
}
